import base from './base'

let controller = 'KVS'
let action = null

const KVS = {
  async list (query, pageIndex = 1, pageSize = 20) {
    let querys = {
      currentPage: pageIndex || query.pageIdex,
      pageSize: pageSize || query.pageSize,
      sort: query.sort,
      ascending: query.ascending
    }
    Object.assign(querys, query)
    action = 'List'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: querys
    }
    return base.request(reqModel)
  },

  async add (request) {
    let model = {
      key: request.key || null,
      value: request.value || null
    }
    action = 'Create'
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async update (request) {
    let model = {
      id: request.id || request.tid || null,
      key: request.key || null,
      value: request.value || null
    }
    if (!model.id) {
      throw new Error('提交数据不合法!ID为空')
    }
    action = `Update/${model.id}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true,
      data: model
    }
    return base.request(reqModel)
  },

  async delete (tid) {
    if (!tid) {
      throw new Error('Tid为空')
    }
    action = `Delete/${tid}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  },

  async getKVS (key) {
    if (!key) {
      throw new Error('Key为空')
    }
    action = `GetByKey/${key}`
    let reqModel = {
      method: 'POST',
      controller: controller,
      action: action,
      auth: true
    }
    return base.request(reqModel)
  }
}

export default KVS